import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { valInputFields } from '../FinalSaction.module.css';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import _ from 'lodash';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import * as Yup from 'yup';
import {
  uploadValuationDocs,
  UploadFileToS3,
  uploadedValuationDocs,
  addUpdateTheSanction
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';
import InputTypeNumber from '../../../../common/components/InputTypeNumber/InputTypeNumber';
import moment from 'moment';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import { show_image } from './Valuation.module.css';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';

const commonClasses = `w-full px-3 my-4 float-left xl:w-6/12 ${valInputFields}`;
const commonInputEffect = { height: '52px', maxWidth: '100%' };

const AddValuation = ({ parentController }) => {
  const [popUpData, setPopUpData] = useState({
    type: 'loading',
    text: 'Loading'
  });
  const [popUpshow, setPopUpShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [autoClose, setAutoClose] = useState(false);
  const [storeDocIds, setDocIds] = useState({
    'sale-agreement': '',
    'plan-copy': '',
    report: ''
  });
  const [planCopyPrevFile, setPlanCopyPrev] = useState(false);
  const [saleAggPrevFile, setPlanSaleAgg] = useState(false);
  const [valReportPrevFile, setValReport] = useState(false);

  // yup validation schema
  const validateSchema = Yup.object().shape({
    agency_name: Yup.string().required('required'),
    person_name: Yup.string().required('required'),
    contact_no: Yup.string()
      .required('required')
      .length(10, 'must be 10 digit!'),
    email_id: Yup.string()
      .required('required')
      .email('not a valid email'),
    sub_mth: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    sub_yr: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    sub_dt: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    file: Yup.array().test(value => {
      let isTrue = true;
      if (!valReportPrevFile && !_.get(value, '[2][0]', false)) isTrue = false;
      if (!saleAggPrevFile && !_.get(value, '[0][0]', false)) isTrue = false;
      if (!planCopyPrevFile && !_.get(value, '[1][0]', false)) isTrue = false;
      return isTrue;
    }),
    val_amt: Yup.string().required('required')
  });

  // initialise the pop-up based on the type and messsage
  const initialisePopUp = ({ type = null, message }) => {
    if (!message) return;
    if (type === 'fail')
      setPopUpData({ type: 'fail', text: message.toString() });
    else if (type == 'success')
      setPopUpData({ type: 'success', text: message.toString() });
    else setPopUpData({ type: 'loading', text: message.toString() });
    setPopUpShow(true);
    setDontClose(true);
  };

  // submit the data to server
  const submitTheData = (parentStateAndFunctions, formikFunctions) => {
    parentStateAndFunctions?.initialisePopUp({
      message: 'Uploading the file please wait...'
    });
    parentStateAndFunctions?.setAutoClose(false);
    let month = _.get(formikFunctions, 'values.sub_mth.value', '0').toString(),
      date = _.get(formikFunctions, 'values.sub_dt.value', '0').toString();
    if (month.length == 1)
      month = '0' + _.get(formikFunctions, 'values.sub_mth.value', '0');
    if (date.length == 1)
      date = '0' + _.get(formikFunctions, 'values.sub_dt.value', '0');

    let body = {
      valuationNumber: parentStateAndFunctions?.currentValuation,
      agencyName: _.get(formikFunctions, 'values.agency_name', ''),
      personName: _.get(formikFunctions, 'values.person_name', ''),
      contactNumber: _.get(formikFunctions, 'values.contact_no', ''),
      emailId: _.get(formikFunctions, 'values.email_id', ''),
      valuationAmount: _.get(formikFunctions, 'values.val_amt', 0),
      submittedDate: `${_.get(
        formikFunctions,
        'values.sub_yr.value',
        ''
      )}-${month}-${date}`,
      saleAgreementDocId: parentStateAndFunctions.storeDocIds['sale-agreement'],
      planCopyDocId: parentStateAndFunctions.storeDocIds['plan-copy'],
      valuationReportDocId: parentStateAndFunctions.storeDocIds['report']
    };
    addUpdateTheSanction(getApplicantionInfo().leadId, 'valuation', body)
      .then(res => {
        if (res.error) throw new Error(res);

        parentStateAndFunctions.setPopUpShow(false);
        parentController.setStep('viewValuation');
      })
      .catch(error => {
        parentStateAndFunctions.setPopUpShow(false);
      });
  };

  // return statement for the
  return (
    <div className="w-full xl:px-1 mt-6 mb-5">
      <Formik
        initialValues={{
          step: { label: 'Final Sanction', value: 'finl_sctn' },
          sub_mth: { label: 'Month', value: '' },
          sub_yr: {
            label: moment().format('YYYY'),
            value: moment().format('YYYY')
          },
          sub_dt: { label: 'Date', value: '' },
          file: [],
          imgUrl: []
        }}
        validationSchema={validateSchema}
      >
        {({
          setFieldValue,
          touched,
          values,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldTouched,
          validateForm
        }) => {
          useEffect(() => {
            if (!_.get(parentController, 'responseContainer.valuationDetails'))
              return;
            const data = _.get(
              parentController,
              'responseContainer.valuationDetails'
            );
            let date = moment(data?.submittedDate, 'YYYY-MM-DD');
            setFieldValue('agency_name', _.get(data, 'agencyName', ''));
            setFieldValue('person_name', _.get(data, 'personName', ''));
            setFieldValue('contact_no', _.get(data, 'contactNumber', ''));
            setFieldValue('email_id', _.get(data, 'emailId', ''));
            setFieldValue('val_amt', _.get(data, 'valuationAmount', ''));

            setFieldValue('sub_yr', {
              value: date.year(),
              label: date.year()
            });
            setFieldValue('sub_mth', {
              value: date.month() + 1,
              label: date.format('MMMM')
            });
            setFieldValue('sub_dt', {
              value: date.date(),
              label: date.format('DD')
            });
            fileHandler();
          }, []);

          const fileHandler = async () => {
            if (!_.get(parentController, 'responseContainer', false)) return;
            const mainData = parentController.responseContainer;
            if (mainData.planCopyDocLink) {
              setFieldValue('prevPlnCopy', mainData.planCopyDocLink);
              setPlanCopyPrev(true);
              updateDocId(
                _.get(mainData, 'planCopyDocLink.docId', 0),
                'plan-copy'
              );
            }
            if (mainData.saleAgreementDocLink) {
              setFieldValue('prevSaleAgg', mainData.saleAgreementDocLink);
              setPlanSaleAgg(true);
              updateDocId(
                _.get(mainData, 'saleAgreementDocLink.docId', 0),
                'sale-agreement'
              );
            }
            if (mainData.valuationReportDocLink) {
              setFieldValue('valReport', mainData.valuationReportDocLink);
              setValReport(true);
              updateDocId(
                _.get(mainData, 'valuationReportDocLink.docId', 0),
                'report'
              );
            }
          };

          // consiste of all formik function
          const formikFunctions = {
            setFieldValue: setFieldValue,
            touched: touched,
            errors: errors,
            values: values,
            handleChange: handleChange,
            handleBlur: handleBlur,
            handleSubmit: handleSubmit,
            setFieldTouched: setFieldTouched
          };

          // validate the form on every click on submit button, retun null if any error occured otherwise saves data in server.
          const handleSubmition = () => {
            validateForm().then(res => {
              if (Object.keys(res).length != 0) return handleSubmit();
              submitTheData(parentStateAndFunctions, formikFunctions);
            });
          };

          // update the uploaded doc id for the name
          const updateDocId = (id, name) => {
            if (!id || !name) throw new Error();
            let docIds = parentStateAndFunctions.storeDocIds;
            docIds[name.toString()] = id;
            parentStateAndFunctions.setDocIds(docIds);
          };

          //consiste of all state and its function
          const parentStateAndFunctions = {
            initialisePopUp: initialisePopUp,
            setCurrValuation: parentController?.setCurrValuation,
            currentValuation: parentController?.currentValuation,
            popUpshow: popUpshow,
            setPopUpShow: setPopUpShow,
            storeDocIds: storeDocIds,
            setDocIds: setDocIds,
            updateDocId: updateDocId,
            autoClose: autoClose,
            setAutoClose: setAutoClose
          };
          return (
            <Form className={`w-full`}>
              <div className="w-full">
                <div className="w-full">
                  <GetPageHeader />
                </div>
                <div className="w-full">
                  <ShowDataFileds
                    formikFunctions={formikFunctions}
                    parentStateAndFunctions={parentStateAndFunctions}
                  />
                </div>
                <div className="w-full">
                  <ShowUploadFields
                    formikFunctions={formikFunctions}
                    parentStateAndFunctions={parentStateAndFunctions}
                  />
                </div>
                <div className="w-full">
                  <PopUp
                    type={popUpData.type}
                    text={popUpData.text}
                    setShow={setPopUpShow}
                    show={popUpshow}
                    dontClose={dontClose}
                    autoClose={autoClose}
                  />
                </div>
                <div className="w-full clear-both">
                  <button
                    type="button"
                    className="submitButton font-roboto text-white text-base w-48 "
                    disabled={Object.keys(formikFunctions.errors).length != 0}
                    onClick={handleSubmition}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const GetPageHeader = () => {
  return (
    <div className="w-full">
      <p className="text-black-1011 font-roboto font-medium text-base px-3 ">
        Valuation Details
      </p>
    </div>
  );
};

const ShowDataFileds = ({ formikFunctions, parentStateAndFunctions }) => {
  const handleCommonFunction = name => {
    return {
      onChange: formikFunctions?.handleChange,
      onBlur: formikFunctions?.handleBlur,
      value: formikFunctions?.values[name?.toString()],
      error:
        formikFunctions?.touched[name.toString()] &&
        formikFunctions?.errors[name.toString()],

      stylesContainer: commonInputEffect,
      errorMsg: formikFunctions?.errors[name.toString()],
      touched: formikFunctions?.touched[name.toString()]
    };
  };

  // execute when month gets change in date picker
  const handleonChangeMonth = (value, isValidDate) => {
    formikFunctions?.setFieldValue('sub_mth', value, true);
    formikFunctions?.setFieldTouched('sub_mth', true, false);
    if (!isValidDate) {
      formikFunctions?.setFieldValue(
        'sub_mth',
        {
          value: '',
          label: 'Date'
        },
        true
      );
    }
  };

  // execute when year gets change in date picker
  const handleonChangeYear = (value, isValidDate) => {
    formikFunctions?.setFieldValue('sub_yr', value, true);
    formikFunctions?.setFieldTouched('sub_yr', true, false);

    if (!isValidDate) {
      formikFunctions?.setFieldValue(
        'sub_yr',
        {
          value: '',
          label: 'Date'
        },
        true
      );
    }
  };

  // execute when date gets change in date picker
  const handleonChangeDate = value => {
    formikFunctions?.setFieldValue('sub_dt', value, true);
    formikFunctions?.setFieldTouched('sub_dt', true, false);
  };

  // handle month change when month  gets change
  const handleMonth = name => {
    return {
      valueMonth: formikFunctions?.values[name.toString()],
      errorMonth:
        formikFunctions?.touched[name.toString()] &&
        _.get(formikFunctions?.errors, `${name.toString()}.value`, false),

      touchedMonth: formikFunctions?.touched[name.toString()],
      onBlurMonth: () => {
        formikFunctions?.setFieldTouched(name.toString(), true, true);
      }
    };
  };

  // handle year change when month  gets change
  const handleYear = name => {
    return {
      valueYear: formikFunctions?.values[name.toString()],
      errorYear:
        formikFunctions?.touched[name.toString()] &&
        _.get(formikFunctions?.errors, `${name.toString()}.value`, false),

      touchedYear: formikFunctions?.touched[name.toString()],
      onBlurYear: () => {
        formikFunctions?.setFieldTouched(name.toString(), true, true);
      }
    };
  };

  return (
    <div className="w-full block">
      <div className="w-full  mt-6">
        <div className={`${commonClasses}`}>
          <CommonInput
            name="agency_name"
            legendName="Name of the Agency"
            {...handleCommonFunction('agency_name')}
          />
        </div>
        <div className={`${commonClasses}`}>
          <CommonInput
            name="person_name"
            legendName="Person Name"
            {...handleCommonFunction('person_name')}
          />
        </div>
        <div className={`mobile_field ${commonClasses}`}>
          <div className="grid_input_container relative ">
            <div
              style={{ marginTop: '17px' }}
              className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
            >
              +91
            </div>
            <div>
              <CommonInput
                name="contact_no"
                maxLength={10}
                {...handleCommonFunction('contact_no')}
                inputStyle={{
                  paddingLeft: '45px',
                  letterSpacing: '1px'
                }}
                onBlurStyle={{
                  paddingLeft: '20px'
                }}
                legendStyle={{
                  paddingLeft: '20px'
                }}
                legendName="Contact No."
                className={`pt-24`}
              />
            </div>
          </div>
        </div>{' '}
        <div className={`${commonClasses}`}>
          <CommonInput
            name="email_id"
            legendName="Email Id"
            {...handleCommonFunction('email_id')}
          />
        </div>
      </div>
      <div
        className={`w-full px-3 my-4 xxl:w-6/12 float-left ${valInputFields}`}
      >
        <div className="w-full">
          <div className=" mb-1 w-full ">Date Submitted</div>
          <CommonDatePicker
            styleHeight={{ height: '52px' }}
            onChangeMonth={(value, isValidDate) => {
              handleonChangeMonth(value, isValidDate);
            }}
            onChangeYear={(value, isValidDate) => {
              handleonChangeYear(value, isValidDate);
            }}
            onChangeDate={value => {
              handleonChangeDate(value);
            }}
            valueDate={formikFunctions?.values.sub_dt}
            {...handleYear('sub_yr')}
            {...handleMonth('sub_mth')}
            errorDate={
              formikFunctions?.touched.sub_mth &&
              _.get(formikFunctions?.errors, 'sub_mth.value', false)
            }
            touchedDate={formikFunctions?.touched.sub_mth}
            onBlurDate={() => {
              formikFunctions?.setFieldTouched('sub_dt', true, true);
            }}
            disableFuture={true}
          />
        </div>
      </div>
    </div>
  );
};

const ShowUploadFields = ({ formikFunctions, parentStateAndFunctions }) => {
  let current_valuation = false;
  if (!parentStateAndFunctions?.currentValuation) throw new Error();
  current_valuation = parentStateAndFunctions?.currentValuation;

  //document list add/remove to change  documents to be upload
  const documentList = [
    {
      label: 'Sale Agreement',
      index: 0,
      name: 'prevSaleAgg'
    },
    {
      label: 'Plan Copy ',
      index: 1,
      name: 'prevPlnCopy'
    },
    {
      label: 'Valuation Report',
      index: 2,
      name: 'valReport'
    }
  ];

  // it is consists of formik function, which are mostly common to all
  const handleCommonFunction = name => {
    return {
      onChange: formikFunctions?.handleChange,
      onBlur: formikFunctions?.handleBlur,
      value: numberFormat(formikFunctions?.values[name?.toString()]),
      error:
        formikFunctions?.touched[name?.toString()] &&
        formikFunctions?.errors[name.toString()],

      stylesContainer: commonInputEffect,
      errorMsg: formikFunctions?.errors[name.toString()],
      touched: formikFunctions?.touched[name.toString()],
      setFieldValue: formikFunctions?.setFieldValue
    };
  };

  // get S3 url for the for upload the file
  const getS3Url = (docName, current_valuation, index) => {
    parentStateAndFunctions?.initialisePopUp({
      message: 'Uploading the file please wait...'
    });
    parentStateAndFunctions?.setAutoClose(false);
    uploadValuationDocs(
      getApplicantionInfo().leadId,
      docName,
      current_valuation
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        uploadFile(res, docName, index);
      })
      .catch(error => parentStateAndFunctions?.setPopUpShow(false));
  };

  // upload the file  to the s3
  const uploadFile = (res, docName, index) => {
    const fileObject = formikFunctions.values.file[index][0];
    if (!res.url || !res.requestId) throw new Error(res);
    UploadFileToS3(res.url, fileObject).then(s3res => {
      if (s3res.error) throw new Error(s3res);
      registerUploadFile(res, docName);
    });
  };

  // register the docId  of the file in server
  const registerUploadFile = (res, docName) => {
    uploadedValuationDocs(
      getApplicantionInfo().leadId,
      docName,
      res.requestId
    ).then(uploadedRes => {
      parentStateAndFunctions?.updateDocId(res.requestId, docName);
      if (uploadedRes.error) throw new Error(uploadedRes);
      parentStateAndFunctions?.setPopUpShow(false);
      parentStateAndFunctions?.initialisePopUp({
        message: 'The File Uploaded Successfully!',
        type: 'success'
      });
      parentStateAndFunctions?.setPopUpShow(true);
      parentStateAndFunctions?.setAutoClose(true);
    });
  };

  // uploads sale-agreement file, calls when values.file[0] gets changed
  useEffect(() => {
    if (!_.get(formikFunctions, 'values.file[0][0]', false)) return;
    getS3Url('sale-agreement', current_valuation, 0);
  }, [formikFunctions?.values?.file[0]]);

  // uploads plan-copy file, calls when values.file[1] gets changed
  useEffect(() => {
    if (!_.get(formikFunctions, 'values.file[1][0]', false)) return;
    getS3Url('plan-copy', current_valuation, 1);
  }, [formikFunctions?.values?.file[1]]);

  // uploads valuation report file, calls when values.file[2] gets changed
  useEffect(() => {
    if (!_.get(formikFunctions, 'values.file[2][0]', false)) return;
    getS3Url('report', current_valuation, 2);
  }, [formikFunctions?.values?.file[2]]);

  return (
    <div className="w-full float-right my-4 px-2">
      <div className="w-full my-5">Please Upload the Documents</div>
      <div className="w-full flex flex-wrap">
        {documentList.map((each, index) => (
          <div className="w-auto px-1 my-3" key={index}>
            <p className="w-full text-sm font-roboto font-normal text-grey-300 mb-2">
              {each.label}
            </p>
            <div className={` ${each.index == 2 ? 'xl:flex ml-1 ' : 'block'}`}>
              {formikFunctions?.values[each.name.toString()] ? (
                <div className={`${show_image}`}>
                  <ShowGetImage
                    img={_.get(formikFunctions, `values[${each.name}].url`, '')}
                    setEdit={() =>
                      formikFunctions.setFieldValue(each.name, false)
                    }
                  />
                </div>
              ) : (
                <GlobalUploadComp
                  data={formikFunctions?.values}
                  imgIndex={each.index} //0,1,2,3 depending upon the no of file sequence
                  errors={formikFunctions?.errors}
                  touched={formikFunctions?.touched}
                  handleChange={formikFunctions?.handleChange}
                  handleBlur={formikFunctions?.handleBlur}
                  setFieldValue={formikFunctions?.setFieldValue}
                  setFieldTouched={formikFunctions?.setFieldTouched}
                  setFieldError={formikFunctions?.setFieldError}
                  initialImg={initialImg} // initial image
                  subInst="click here or  drop here to upload "
                />
              )}
              {each.index == 2 ? (
                <div className="w-full mt-4">
                  <div
                    className={`w-full xl:px-3  float-left xl:w-6/12 xl:mx-4 -my-1 ${valInputFields}`}
                  >
                    <div className="w-full font-roboto font-normal text-sm text-grey-300">
                      Valuation amount
                    </div>
                    <InputTypeNumber
                      name="val_amt"
                      maxLength={10}
                      minLength={0}
                      {...handleCommonFunction('val_amt')}
                      inputStyle={{
                        color: 'rgb(62 204 62 / 83%)',
                        fontSize: '19px',
                        fontWeight: '700',
                        paddingLeft: '40px'
                      }}
                      showInText={false}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withErrorHandler(AddValuation);
